import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'error-location',
    templateUrl: './error-location.component.html',
    styleUrls: ["./error-location.component.css"],
})
export class ErrorLocationComponent {
    isRefSPay: boolean = false;
    metter: number = 0;

    constructor(
        private cd: ChangeDetectorRef,
        private ngZone: NgZone,
        private router: Router) {
        if (this.router.getCurrentNavigation().extras.state) {
            this.metter = this.router.getCurrentNavigation().extras.state.Distance;
            this.isRefSPay = !!this.router.getCurrentNavigation().extras.state.Ref;
            localStorage.setItem("InfoLocation", JSON.stringify({ Distance: this.router.getCurrentNavigation().extras.state.Distance, IsRefSpay: this.isRefSPay }));
        }
    }

    ngOnInit() {
        var data = localStorage.getItem("InfoLocation");
        if (this.metter == 0 && data) {
            let info = JSON.parse(data);
            this.metter = info.Distance;
            this.isRefSPay = info.IsRefSpay
        }
    }
}
